/**
 * 직접 파일 업로드 컴포넌트
 * 계약서와 계약 필요 서류를 업로드하는 컴포넌트입니다.
 * 계약서와 계약 필요 서류를 각각 최대 10개까지 업로드할 수 있습니다.
 */

import _ from "lodash";
import { useEffect, useState } from "react";
import { ContractDetail, ContractMedia, disabledEsignEdit } from "src/api/contract/contract-types";
import { SaveMediaDto } from "src/api/organization/org-types";
import ContractImageUpload from "./ContractImageUpload";

/**
 * 직접 파일 업로드 컴포넌트의 props 인터페이스
 */
interface Props {
  contract: ContractDetail; // 계약 정보
  editContract: ContractDetail; // 편집 중인 계약 정보
  setEditContract: any; // 계약 정보 업데이트 함수
}

/**
 * 직접 파일 업로드 컴포넌트
 * @param contract 계약 정보
 * @param editContract 편집 중인 계약 정보
 * @param setEditContract 계약 정보 업데이트 함수
 */
const DirectFileUpload = ({ contract, editContract, setEditContract }: Props) => {
  const [uploadMediaFileMain, setUploadedMediaFileMain] = useState<SaveMediaDto[]>([]); // 계약서 파일 목록
  const [uploadMediaFileSub, setUploadedMediaFileSub] = useState<SaveMediaDto[]>([]); // 계약 필요 서류 파일 목록

  /**
   * 편집 중인 계약 정보가 변경될 때 파일 목록을 설정하는 효과
   */
  useEffect(() => {
    if (editContract && editContract.mediaList) {
      const main = editContract?.mediaList?.filter((media: ContractMedia) => media.serviceTag === "CONTRACT_DOCUMENT") as any[];
      const sub = editContract?.mediaList?.filter((media: ContractMedia) => media.serviceTag !== "CONTRACT_DOCUMENT") as any[];

      setUploadedMediaFileMain(main);
      setUploadedMediaFileSub(sub);
    }
  }, [editContract]);

  return (
    <div className="flex-start">
      {/* 계약서 */}
      <section className="contents-container__grid">
        <div className="contents-container__grid-index">
          <p>{`계약서 (${uploadMediaFileMain.length}/10)`}</p>
        </div>
        <ContractImageUpload
          type="PROOF"
          serviceTag={"CONTRACT_DOCUMENT"}
          fileMaxLength={10}
          images={uploadMediaFileMain}
          setImages={(files: any) => {
            const temp = _.cloneDeep(editContract!);

            const sub = temp?.mediaList?.filter((media: ContractMedia) => media.serviceTag !== "CONTRACT_DOCUMENT") as any[];
            temp.mediaList = [...(files as any[]), ...(sub as any[])];

            setUploadedMediaFileMain(files);
            temp.mediaList.forEach((mediaFile: ContractMedia, index: number) => {
              mediaFile["orderNums"] = index + 1;
              if (!mediaFile.id) {
                mediaFile["cmdType"] = "C";
              }
              if (index === 0) {
                mediaFile["isPrimary"] = true;
              } else {
                mediaFile["isPrimary"] = false;
              }
            });
            setEditContract(temp);
          }}
          disabled={disabledEsignEdit.includes(contract?.contractStep!)}
        />
      </section>

      {/* 계약 필요 서류 */}
      <section className="contents-container__grid">
        <div className="contents-container__grid-index">
          <p>{`계약 필요 서류 (${uploadMediaFileSub.length}/10)`}</p>
        </div>
        <div className="contents-container__grid-contents">
          <ContractImageUpload
            type="PROOF"
            serviceTag={"CONTRACT_REQUIRED"}
            fileMaxLength={10}
            images={uploadMediaFileSub}
            setImages={(files) => {
              setUploadedMediaFileSub(files);
              const temp = _.cloneDeep(editContract!);

              const main = editContract?.mediaList?.filter((media: ContractMedia) => media.serviceTag === "CONTRACT_DOCUMENT") as any[];
              temp.mediaList = [...(files as any[]), ...(main as any[])];

              setUploadedMediaFileMain(files);
              temp.mediaList.forEach((mediaFile: ContractMedia, index: number) => {
                mediaFile["orderNums"] = index + 1;
                if (!mediaFile.id) {
                  mediaFile["cmdType"] = "C";
                }
                if (index === 0) {
                  mediaFile["isPrimary"] = true;
                } else {
                  mediaFile["isPrimary"] = false;
                }
              });
              setEditContract(temp);
            }}
            disabled={disabledEsignEdit.includes(contract?.contractStep!)}
          />
        </div>
      </section>
    </div>
  );
};
export default DirectFileUpload;
